import api from '../api'

export const getContractorCompanyProfile = (slug: string) => {
  return api.get(`/contractor/v2/companies/${slug}`, {
    role: 'contractor',
  })
}

export const getContractorMiningCompanySearchAccess = () => {
  return api.get('/contractor/v2/companies/access', {
    role: 'contractor',
  })
}

export const getContractorMiningCompanies = (params: Record<string, unknown>) => {
  return api.get('/contractor/v2/companies', {
    role: 'contractor',
    params,
  })
}

export const getContractorCompanyRecentActivity = (params: Record<string, unknown>) => {
  return api.get('/contractor/v2/companies/recent-activity', {
    role: 'contractor',
    params,
  })
}

export const bookmarkContractorCompany = (companyId: number) => {
  return api.post(`/contractor/v2/companies/${companyId}/bookmark`, null, {
    role: 'contractor',
  })
}

export const removeContractorCompanyBookmark = (companyId: number) => {
  return api.delete(`/contractor/v2/companies/${companyId}/bookmark`, {
    role: 'contractor',
  })
}

export const getContractorCompanyMatches = (contractorId: number, payload: Record<string, unknown>) => {
  return api.post(`/matching/v1/contractors/${contractorId}/companies`, payload)
}
